import * as React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

function MainFeaturedPost(props) {
  const { post } = props;

  return (
    <Paper
      sx={{
        position: 'relative',
        backgroundColor: 'grey.800',
        color: '#fff',
        mb: 1,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${post.image})`,
        width: '100%', // 全幅表示
        borderRadius: 1,
        overflow: 'hidden',
        height: '100px',
      }}
    >
      {/* 画像の上に暗いオーバーレイを追加 */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: 'rgba(0,0,0,.3)',
        }}
      />
      <Grid container>
        <Grid item md={6}>
          <Box
            sx={{
              position: 'relative',
              p: { xs: 3, md: 4 },   //md値であらふぉーの縦位置調整
              pr: { md: 0 },
              display: 'flex',            // 追加
              flexDirection: 'column',    // 縦に並べる
              justifyContent: 'center',   // ← 上下の中央に配置（topにしたければ 'flex-start'、下なら 'flex-end'）
            }}
          >
            {/* <Typography component="h1" variant="h3" color="inherit" gutterBottom>
              {post.title}
            </Typography> */}

            <Typography 
              component="h1" 
              variant="h3" // ★ ここを h4 や h5 に変更すると小さくなる
              sx={{ fontSize: '5.3rem !important', fontWeight: 'bold' , pl: 8}} // ★ ここでサイズ変更
            >
              {post.title}
            </Typography>

            <Typography variant="h5" color="inherit" paragraph>
              {post.description}
            </Typography>
            {post.linkText && (
              <Link variant="subtitle1" href="#">
                {post.linkText}
              </Link>
            )}
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}

MainFeaturedPost.propTypes = {
  post: PropTypes.shape({
    description: PropTypes.string,
    image: PropTypes.string,
    imageText: PropTypes.string,
    linkText: PropTypes.string,
    title: PropTypes.node,
  }).isRequired,
};

export default MainFeaturedPost;